module.exports = __webpack_public_path__ + "static/img/W020211231398298104137Bf@2x(1).05447882.png";